/**
 * StandardConfigBasicFields
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { Input } from '@/components/ui/form/input';

import { useFlowOptimizerMetadata } from '../../hooks';

export interface StandardConfigBasicFieldsProps {
  standardJson: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
}

const StandardConfigBasicFields: FC<StandardConfigBasicFieldsProps> = ({
  standardJson,
  onChange,
}) => {
  const metadata = useFlowOptimizerMetadata();
  const name = typeof standardJson.name === 'string' ? standardJson.name : '';
  const note = typeof standardJson.note === 'string' ? standardJson.note : '';
  const redirect =
    typeof standardJson.defaultOfferRedirectMode === 'string'
      ? standardJson.defaultOfferRedirectMode
      : 'REGULAR';

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      <label className="space-y-1 text-sm">
        <span className="font-medium text-foreground">Flow Name</span>
        <Input
          value={name}
          onChange={(e) => onChange({ ...standardJson, name: e.target.value })}
          placeholder="My optimized flow"
        />
      </label>
      <label className="space-y-1 text-sm">
        <span className="font-medium text-foreground">Default Offer Redirect</span>
        <select
          value={redirect}
          onChange={(e) =>
            onChange({ ...standardJson, defaultOfferRedirectMode: e.target.value })
          }
          className="h-10 w-full rounded-md border border-input bg-background px-3 text-sm"
        >
          {(metadata.data?.redirectModes ?? ['REGULAR', 'HTML', 'DOUBLE_HTML', 'REDIRECTLESS']).map(
            (mode) => (
              <option key={mode} value={mode}>
                {mode}
              </option>
            ),
          )}
        </select>
      </label>
      <label className="space-y-1 text-sm md:col-span-2">
        <span className="font-medium text-foreground">Note</span>
        <Input
          value={note}
          onChange={(e) => onChange({ ...standardJson, note: e.target.value })}
          placeholder="Optional note for this flow"
        />
      </label>
    </div>
  );
};

export default StandardConfigBasicFields;
